import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=14a95670&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=14a95670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a95670",
  null
  
)

export default component.exports